module.exports = __webpack_public_path__ + "img/billing_payment_info_card_current.b4729772.svg";